// File: stacks/workout/app/src/config/equipment.js

// Centralized equipment configuration based on a more comprehensive list.

export const EQUIPMENT_CATEGORIES = {
  Basic: [
    "Bodyweight",
    "Resistance Bands",
    "Jump Rope",
    "Foam Roller",
    "Yoga Mat",
  ],
  "Free Weights": [
    "Dumbbells",
    "Kettlebells",
    "Barbell",
    "Olympic Bar",
    "Weight Plates",
    "EZ Curl Bar",
  ],
  Machines: [
    "Cable Machine",
    "Smith Machine",
    "Leg Press",
    "Lat Pulldown",
    "Chest Press Machine",
  ],
  Cardio: [
    "Treadmill",
    "Assault Bike",
    "Rower",
    "Elliptical",
    "Stair Climber",
    "Spin Bike",
    "Ski Erg",
  ],
  Functional: [
    "Pull-up Bar",
    "Dip Station",
    "Squat Rack",
    "Power Rack",
    "TRX",
    "Battle Ropes",
    "Plyo Box",
    "Sled",
  ],
  Accessories: [
    "Ab Roller",
    "Gym Ball",
    "Medicine Ball",
    "Slam Ball",
    "Sandbag",
    "Bosu Ball",
    "Resistance Bands",
  ],
  Unconventional: [
    "Beer Kegs",
    "Tires",
    "Sledgehammer",
    "Chains",
    "Weight Vest",
    "Bulgarian Bag",
  ],
  "Home Gym Essentials": [
    "Adjustable Bench",
    "Power Tower",
    "Hex Bar",
    "Landmine Attachment",
    "Weight Vest",
  ],
};

export const EQUIPMENT_PRESETS = {
  "Bodyweight Only": ["Bodyweight"],
  Minimal: ["Resistance Bands", "Jump Rope", "Bodyweight"],
  "Home Gym": [
    // All Basic equipment
    "Bodyweight",
    "Resistance Bands",
    "Jump Rope",
    "Foam Roller",
    "Yoga Mat",
    // Additional home gym equipment
    "Kettlebells",
    "Olympic Bar",
    "Weight Plates",
    "Assault Bike",
    "Rower",
    "Pull-up Bar",
    "Dip Station",
    "Squat Rack",
    "TRX",
    "Ab Roller",
    "Medicine Ball",
    "Slam Ball",
    "Sandbag",
    "Beer Kegs",
    "Sledgehammer",
    "Tires",
    "Weight Vest",
  ],
  "Full Gym": [
    "Dumbbells",
    "Barbell",
    "Olympic Bar",
    "Squat Rack",
    "Cable Machine",
    "Pull-up Bar",
    "Assault Bike",
    "Rower",
  ],
  "CrossFit Box": [
    "Olympic Bar",
    "Kettlebells",
    "Pull-up Bar",
    "Assault Bike",
    "Rower",
    "Medicine Ball",
    "Jump Rope",
    "Battle Ropes",
  ],
};

// Flatten all equipment from categories into a single array with unique values
const allEquipmentSet = new Set();
Object.values(EQUIPMENT_CATEGORIES).forEach((categoryItems) => {
  categoryItems.forEach((item) => allEquipmentSet.add(item));
});
export const ALL_EQUIPMENT = Array.from(allEquipmentSet).sort();

// The flat list of options, still useful for simpler components or data processing.
export const ALL_EQUIPMENT_OPTIONS = ALL_EQUIPMENT.map((e) => ({
  value: e,
  label: e,
}));

// New format for the enhanced Combobox: an array of objects, where each object is a category.
export const EQUIPMENT_OPTIONS_WITH_CATEGORIES = Object.entries(
  EQUIPMENT_CATEGORIES
)
  .map(([category, items]) => ({
    label: category,
    options: items.map((item) => ({ value: item, label: item })),
  }))
  .sort((a, b) => a.label.localeCompare(b.label)); // Sort categories alphabetically

// Maps the training location dropdown to a default equipment preset.
export const EQUIPMENT_LOCATION_MAP = {
  None: EQUIPMENT_PRESETS["Bodyweight Only"],
  Home: [
    "Bodyweight",
    "Resistance Bands",
    "Dumbbells",
    "Kettlebells",
    "Pull-up Bar",
    "Adjustable Bench",
    "Yoga Mat",
    "Foam Roller",
    "Jump Rope",
  ],
  Gym: EQUIPMENT_PRESETS["Full Gym"],
  Outdoor: ["Bodyweight", "Jump Rope", "Resistance Bands"],
};
